import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { Form, notification } from "antd";
import { buildEFileRequest, buildEFileOptionsRequest } from "../../state/connect-api";
import { useGetEFileOptionsQuery, useGetEFileQuestionsMutation, useSubmitEFileMutation } from "../../state/e-file-api";
import { updateEFileQuestions, updateActiveEFileOption, resetAllEFile } from "../../state/eFileStore";
import { EFileOption } from "../../models/e-file/e-file-option";
import { RootState } from "../../store";
import { EFileQuestion } from "../../models/e-file/e-file-question";

const useEFile = () => {
  const { activeEFileOption, eFileQuestions } = useSelector((state: RootState) => state.eFileApi);
  const { activeCaseNumber } = useSelector((state: RootState) => state.global);
  const { data: eFileData, isLoading: optionsLoader } = useGetEFileOptionsQuery(buildEFileOptionsRequest());
  const [getEFileQuestions] = useGetEFileQuestionsMutation();
  const [submitEFile] = useSubmitEFileMutation();
  const dispatch = useDispatch();
  const history = useNavigate();
  const [eFileForm] = Form.useForm();


  const selectOption = async (selectedOption: EFileOption) => {
    const request = buildEFileOptionsRequest(selectedOption.OptionId.toString(), selectedOption.OptionId.toString());
    const res = await getEFileQuestions(request).unwrap();
    if (activeEFileOption?.OptionId != selectedOption.OptionId) {
      dispatch(updateEFileQuestions(res));
      dispatch(updateActiveEFileOption(selectedOption));
    }
    let route = "/EFile/Questions";
    history(route);
  };

  const redirectToLookup = () => {
    let route = "/lookup";
    history(route);
  };

  const submitAnswers = async () => {
    const formValues = await eFileForm.validateFields();
    const eFileAnswers: EFileQuestion[] = eFileQuestions?.List.map(question =>
    ({
      QuestionId: question.QuestionId,
      QuestionText: question.QuestionText,
      Answer: formValues[question.QuestionId].Answer
    }))
    dispatch(updateEFileQuestions(eFileAnswers));
    history("/EFile/Questions/Review")
  }
  const submitEFileRequest = async () => {
    const submittedAnswers: EFileQuestion[] = eFileQuestions?.List.map(question =>
    ({
      QuestionId: question.QuestionId,
      Answer: question.Answer
    }))
    const request = buildEFileRequest(activeCaseNumber, activeEFileOption?.OptionId, submittedAnswers);
    const response = await submitEFile(request).unwrap();
    if (response?.IsSuccess) {
      notification.success({ message: "E-File submitted successfully" });
      history("/home")
      dispatch(resetAllEFile());
    }
    else {
      notification.error({ message: "Error submitting E-File" });

    }
  }

  return { selectOption, eFileData, optionsLoader, submitAnswers, eFileForm, redirectToLookup, submitEFileRequest, };

};

export default useEFile;
